import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { ID, SuccessResponse } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useInviteIndependentIraUser = () => {
  const queryClient = useQueryClient();
  const mutate = async (id: ID) => {
    const { data } = await api.inviteIndependentIraUser(id);

    return data;
  };

  const mutationKey = MutationKeys.inviteIndependentIraUser;

  return useMutation<SuccessResponse, AxiosError<ApiError>, ID>(mutationKey, mutate, {
    onSuccess: (_, id) => {
      queryClient.invalidateQueries(QueryKeys.independentIraUsers);
      queryClient.invalidateQueries([QueryKeys.independentIraUser, id]);
    },
  });
};
